import { put } from 'redux-saga/effects';
import { getHelp } from './backend';
import { fetchHelpFail, fetchHelpSuccess } from './actions';
import { makeErrorPayload } from '../../../../shared/helpers/payload.helper';
import { setErrorToast } from '../../../../shared/toast/redux/actions';

export function* fetchHelpSaga() {
    try {
        const response = yield getHelp();

        yield put(fetchHelpSuccess(response.data));
    } catch (error) {
        const formattedError = makeErrorPayload(error);

        yield put(fetchHelpFail(formattedError));
        yield put(setErrorToast(formattedError));
    }
}
